import React from 'react'
import type { Icon } from 'shared/utils'

const PaperNews = (props: Icon) => {
    const {
        color = 'white',
        size = 22,
        className = 'paper-news',
        ...otherProps
    } = props
    return (
        <svg
            width={size}
            height={size}
            className={className}
            viewBox="0 0 22 24"
            {...otherProps}>
            <path
                d="M15.16 14.362c0 .22-.179.399-.4.399H9.575a.399.399 0 110-.798h5.187c.22 0 .399.178.399.399zm-.4 2.792H9.575a.399.399 0 100 .798h5.187a.399.399 0 100-.798zm0-6.383H9.575a.399.399 0 100 .798h5.187a.399.399 0 100-.798zm6.783-5.186v11.57c0 .22-.18.398-.4.398h-3.59v2.793a3.59 3.59 0 01-3.59 3.59H3.59A3.59 3.59 0 010 20.346c0-.22.179-.4.399-.4H3.19V3.59c0-.22.18-.399.4-.399h3.59V.4c0-.22.178-.399.399-.399h8.377c.1 0 .195.037.268.104L21.41 5.29a.399.399 0 01.076.116v.035a.399.399 0 01.02.104l.036.04zm-5.187-.399h3.826L16.356 1.36v3.826zm-4.643 17.952a3.59 3.59 0 01-1.32-2.393H.817a2.793 2.793 0 002.772 2.393h8.123zm5.042-13.962h-4.787a.399.399 0 01-.399-.4V3.99H3.99v15.958h6.782c.22 0 .4.178.4.399a2.793 2.793 0 005.584 0V9.176zm-.562-.798l-3.826-3.826v3.826h3.826zm4.552 8.377V5.984h-4.788a.399.399 0 01-.398-.399V.798h-7.58V3.19h3.99c.098 0 .193.038.266.104l5.187 5.186a.399.399 0 01.075.116v.036a.399.399 0 01.02.104V16.755h3.228zM7.695 10.09l-1.312 1.317-.515-.515a.399.399 0 00-.562.562l.798.798a.399.399 0 00.562 0l1.596-1.595a.399.399 0 00-.563-.563l-.004-.004zm0 3.192l-1.312 1.316-.515-.515a.399.399 0 00-.562.563l.798.798a.399.399 0 00.562 0l1.596-1.596a.399.399 0 00-.563-.562l-.004-.004zm0 3.191L6.383 17.79l-.515-.515a.399.399 0 00-.562.562l.798.798a.399.399 0 00.562 0l1.596-1.595a.399.399 0 00-.563-.563l-.004-.004zm6.268 5.669a1.795 1.795 0 01-1.795-1.795.2.2 0 10-.4 0 2.198 2.198 0 002.195 2.194.2.2 0 000-.399z"
                fill={color}
                fillRule="nonzero"
            />
        </svg>
    )
}

export { PaperNews }
